module.exports = __webpack_public_path__ + "assets/img/14_904.1f42a4e6.jpg";